export const THEME_STAMP = 'stamp';

export const THEME_TEXT = 'text';

export const ALIGNMENT_HORIZONTAL = 'horizontal';

export const ALIGNMENT_VERTICAL = 'vertical';

export const SINGLE_LINE_CHAR_LIMIT = 18;

export const MULTI_LINE_CHAR_LIMIT = 18;
